export const MapKey = "AIzaSyB3mMuvl8IUlviRZiizBiX7uhsdIqunx94";
export const disqusShortname = "mitech-1";
export const formUrl =
    "https://getform.io/f/22b43bd4-29a7-4795-ba95-6abfe8bf1f39";
